import { EmailInUseError, UnexpectedError } from "../../../domain/errors";
import { CreateElectricityPurchaseRequest } from "../../../domain/usecases";
import { HttpClient, HttpStatusCode } from "../../protocols/http";

export class RemoteCreateElectricityPurchaseRequest
  implements CreateElectricityPurchaseRequest
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<void>
  ) {}

  async create(params: CreateElectricityPurchaseRequest.Params): Promise<void> {
    console.log("CreateElectricityPurchaseRequest", params);
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: "post",
      body: params,
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body!;
      case HttpStatusCode.forbidden:
        throw new EmailInUseError();
      default:
        throw new UnexpectedError();
    }
  }
}

// export namespace RemoteCreateElectricityPurchaseRequest {
//   export type Model = CreateElectricityPurchaseRequest.Model;
// }
